import { restApi } from '../../services/api';

export const dailyUserActivityRepository = () => restApi.post('user-daily-activities');
